import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root',
})
export class GoalsService {
  constructor(private restangular: ApiClient) {}

  getGoalById(goalId: string): Promise<any> {
    return this.restangular.one('goals', goalId).get().toPromise();
  }
}
